export default __webpack_public_path__ + "ed9639b509f8742a0ddfa2cc052fc436.svg";